import { z } from 'zod';

/** Admin user permissions for granular access control */
export const adminPermissionSchema = z.enum([
  'manager', // can see everything except managing other admins
  'normal_user', // can see everything except sales card
  'system_admin', // can see everything and manage everything
]);

export type AdminPermission = z.infer<typeof adminPermissionSchema>;
